import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../index";
import { getCurrencies } from "./thunks";
import { CurrencyData } from "../../entities/currency";

interface CurrencyState {
  loading: boolean;
  loaded: boolean;
  currencies: CurrencyData[];
  currency?: CurrencyData;
}

const initialState: CurrencyState = {
  loading: false,
  loaded: false,
  currencies: [],
};

export const currencySlice = createSlice({
  name: "currency",
  initialState,
  reducers: {
    onHandlerCurrency: (state, action: PayloadAction<CurrencyData>) => {
      state.currency = action.payload;
    },
    onClearState: (state) => {
      state.currency = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCurrencies.pending, (state) => {
      state.loading = true;
      state.loaded = false;
    });
    builder.addCase(getCurrencies.fulfilled, (state, action: PayloadAction<CurrencyData[]>) => {
      state.currencies = action.payload;
      state.loading = false;
      state.loaded = true;
    });
    builder.addCase(getCurrencies.rejected, (state) => {
      state.loading = false;
      state.loaded = true;
    });
  },
});

export const { onHandlerCurrency, onClearState } = currencySlice.actions;
export const selectCurrencyState = (state: RootState) => state.currency;
export default currencySlice.reducer;
